import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ISearchViewModelWorkbenchService = ( createDecorator('searchViewModelWorkbenchService'));
export { ISearchViewModelWorkbenchService };
